import React, { useEffect, useRef } from 'react';
import { useClickStore } from '../store/clickStore';
import { useShallow } from 'zustand/react/shallow';

export default function Measurements({ showMeasurements = true }) {
  const ref = useRef();

  const { clickType, setClickType, setZoomToExtent, setLabels, showLabels } = useClickStore(
    useShallow((state) => ({
      clickType: state.clickType,
      setClickType: state.setClickType,
      setZoomToExtent: state.setZoomToExtent,
      setLabels: state.setLabels,
      showLabels: state.showLabels,
    }))
  );

  useEffect(() => {
    const cursorStyles = {
      pan: 'pointer',
      info: 'help',
      distance: 'crosshair',
      zoom: 'zoom-in',
      color: 'move',
    };
    document.body.style.cursor = cursorStyles[clickType] || 'default';

    return () => {
      document.body.style.cursor = 'default';
    };
  }, [clickType]);

  const handleButtonClick = (id) => {
    setClickType(id);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return;

      if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }

      const key = event.key.toLowerCase();

      switch (key) {
        case 'e':
          event.preventDefault();
          setZoomToExtent(true);
          break;
        case 'p':
          event.preventDefault();
          handleButtonClick('pan');
          break;
        case 'i':
          event.preventDefault();
          handleButtonClick('info');
          break;
        case 'd':
          event.preventDefault();
          handleButtonClick('distance');
          break;
        case 'z':
          event.preventDefault();
          handleButtonClick('zoom');
          break;
        case 'c':
          event.preventDefault();
          handleButtonClick('color');
          break;
        case 'l':
          event.preventDefault();
          setLabels();
          break;
        default:
          return;
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [setZoomToExtent, setLabels]);

  if (!showMeasurements) {
    return null;
  }

  return (
    <div className="absolute top-1 right-12 sm:top-2 sm:right-16" ref={ref}>
      <div className="absolute right-0 mt-0.5 sm:mt-1 bg-white border border-yellow-400 rounded shadow p-0.5 sm:p-1 flex flex-col items-center space-y-0.5 sm:space-y-1 z-50">
        <button
          onClick={() => setZoomToExtent(true)}
          className="bg-gray-500 text-white w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs hover:bg-gray-600 transition-colors duration-200"
          title="Zoom to Extent (E)"
        >
          E
        </button>
        <button
          onClick={() => handleButtonClick('pan')}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            clickType === 'pan' ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Pan Mode (P)"
        >
          P
        </button>
        <button
          onClick={() => handleButtonClick('info')}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            clickType === 'info' ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Info Mode (I)"
        >
          I
        </button>
        <button
          onClick={() => handleButtonClick('distance')}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            clickType === 'distance' ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Distance Measurement (D)"
        >
          D
        </button>
        <button
          onClick={() => handleButtonClick('zoom')}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            clickType === 'zoom' ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Zoom Mode (Z)"
        >
          Z
        </button>
        <button
          onClick={() => handleButtonClick('color')}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            clickType === 'color' ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Color Mode (C)"
        >
          C
        </button>
        <button
          onClick={() => setLabels()}
          className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center text-xs transition-colors duration-200 ${
            showLabels ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
          } hover:bg-gray-600`}
          title="Toggle Labels (L)"
        >
          L
        </button>
      </div>
    </div>
  );
}
